import { types, getRoot } from 'mobx-state-tree'
import Router from "next/router"
import { ToastStore } from './ui/toastStore'

export const UIStore = types
  .model('UIStore', {
    currentHost: types.maybeNull(types.string),
    isMobile: false,
    isTablet: false,
    isSmallDesktop: false,
    isMobileMenuOpen: false,
    isWebkit: false,
    toasts: ToastStore,
    loginModalShowing: false,
    signupModalShowing: false,
    phoneVerifyModalShowing: false,
  })
  .actions(self => {
    return {
      setMobile(isMobileBool) {
        self.isMobile = isMobileBool
      },
      setTablet(isTabletBool) {
        self.isTablet = isTabletBool
      },
      setSmallDesktop(isSmallDesktopBool) {
        self.isSmallDesktop = isSmallDesktopBool
      },
      setCurrentHost(currentHost) {
        self.currentHost = currentHost
      },
      setIsMobileMenuOpen(isMobileMenuOpenBool) {
        self.isMobileMenuOpen = isMobileMenuOpenBool
      },
      setWebkit(isWebkitBool) {
        self.isWebkit = isWebkitBool
      },
      setLoginModalShowing(loginModalShowing) {
        self.loginModalShowing = loginModalShowing
      },
      setSignupModalShowing(signupModalShowing) {
        self.signupModalShowing = signupModalShowing
      },
      setPhoneVerifyModalShowing(phoneVerifyModalShowing) {
        self.phoneVerifyModalShowing = phoneVerifyModalShowing
      },
    }
  })
  .views(self => ({
    get isPayNYCFlow() {
      return Boolean(self.currentHost && self.currentHost.includes("paynyctickets.com"))
    },
    get usePasswordlessLogin() {
      if (self.currentHost && self.currentHost.includes('paynyctickets.com')) {
        return true
      }
      if (process.env.USE_PASSWORDLESS_LOGIN === 'true') {
        return true
      }
      // Vercel preview deploys (login-flow QA) — not production appwinit.com
      if (self.currentHost && self.currentHost.includes('vercel.app')) {
        return true
      }
      if (typeof window !== 'undefined') {
        return Router.pathname === '/parking/pay' || Router.pathname.startsWith('/parking/pay/')
      }
      return false
    },
    get isTrafficFlow() {
        if (typeof window === 'undefined') {
            return false
        }
        // Traffic Lookup runs on /traffic* routes. The manual Traffic Submission
        // flow ALSO renders on landing routes (/, /login, /<state>-traffic-tickets)
        // via pages/[slug].jsx + pages/index.jsx, whose Router.pathname is the
        // route *pattern* ('/[slug]', '/') and does NOT contain 'traffic'. Relying
        // on the URL alone left isTrafficFlow false there, which disabled the CKO
        // payment dropin + its session init (checkout never mounted). Detect the
        // active submission flow via store state as well — mirrors how the parking
        // flow is detected (parkingFlow.flow.*). TrafficSubmissionFlow's
        // componentWillUnmount() calls trafficSubmission.reset() (clears
        // `initialized`), so this cannot bleed into other flows (e.g. parking).
        if (Router.pathname.includes('traffic')) {
            return true // Traffic Lookup or dedicated traffic routes
        }
        const root = getRoot(self)
        return Boolean(root && root.trafficSubmission && root.trafficSubmission.initialized)
    }
  }))
